require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-scheduled-maintenance.json") })
        }
      }, "path---es-articles-scheduled-maintenance");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-scheduled-maintenance!./.cache/json/es-articles-scheduled-maintenance.json
// module id = 2240
// module chunks = 231608221292675